import { render, staticRenderFns } from "./FactureFournisseurListFilters.vue?vue&type=template&id=48de28ee"
import script from "./FactureFournisseurListFilters.vue?vue&type=script&lang=ts"
export * from "./FactureFournisseurListFilters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports